import React from 'react';
import { motion } from 'framer-motion';
export function Services() {
  const services = [{
    title: 'Boat Transport',
    desc: 'Safe and secure nationwide boat transport for powerboats, center consoles, and runabouts.',
    img: 'https://images.unsplash.com/photo-1564346128522-861502472948?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Yacht Transport',
    desc: 'Specialized handling and premium yacht shipping logistics for luxury vessels.',
    img: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Sailboat Transport',
    desc: 'Expert mast removal coordination and custom cradling for safe sailboat hauling.',
    img: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ef?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Pontoon Transport',
    desc: 'Dedicated trailers designed specifically for the safe transport of pontoon boats.',
    img: 'https://images.unsplash.com/photo-1583480076231-15b50d536097?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Jet Ski Shipping',
    desc: 'Affordable and fast transport for personal watercraft, single or multiple units.',
    img: 'https://images.unsplash.com/photo-1559405886-c4e11649c065?q=80&w=800&auto=format&fit=crop'
  }, {
    title: 'Oversized / Wide-Load',
    desc: 'Permit acquisition and escort vehicles for wide-load and oversized boat movers.',
    img: 'https://images.unsplash.com/photo-1580828369019-181321f238bc?q=80&w=800&auto=format&fit=crop'
  }];
  return <section className="py-20 bg-brand-navy text-white" data-id="element-267">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-268">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-269">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-270">
            Comprehensive Boat Transport Services
          </h2>
          <p className="text-lg text-slate-300" data-id="element-271">
            From jet skis to luxury yachts, our boat movers have the equipment
            and expertise to handle any marine transport requirement.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-272">
          {services.map((service, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="group relative overflow-hidden rounded-2xl bg-brand-navy-light border border-white/10" data-id="element-273">
              <div className="aspect-w-16 aspect-h-9 w-full h-64 overflow-hidden" data-id="element-274">
                <img src={service.img} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-275" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/40 to-transparent" data-id="element-276"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-277">
                <h3 className="text-2xl font-bold mb-2" data-id="element-278">{service.title}</h3>
                <p className="text-slate-300" data-id="element-279">{service.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}